"use strict";

import { builderVersion } from '../version.json';

module.exports = ["$scope", "$state", "dialog", "$translate", "clients", "Authentication", "departments", "toast", "$uibModal", "$http", "user", "filesFromApi", "siteConfig", function ($scope, $state, dialog, $translate, clients, Authentication, departments, toast, $uibModal, $http, user, filesFromApi, siteConfig) {
    var _this = this;
    const SHEETS_API_BASE = siteConfig.sheetsApiBase;
    const SHEETS_FRONT_DEV = siteConfig.sheetsFrontUrl;

    this.departments = departments || [];
    this.user = user || [];
    this.clients = clients || [];
    this.quickFilter = "";
    this.sheets = [];
    this.loading = false;

    function mapApiItemToSheet(item) {
        const clientId = item.clientId || null;
        const departmentId = item.departmentId || null;
        const client = clientId && _this.clients.length ? _this.clients.find(function (c) { return c.id === clientId; }) : null;
        const dept = departmentId && _this.departments.length ? _this.departments.find(function (d) { return d.id === departmentId; }) : null;
        return {
            id: item.id || item._id,
            name: item.file || item.name || "",
            client: client ? client.name : null,
            department: dept ? dept.name : null,
            clientId: clientId,
            departmentId: departmentId
        };
    }

    this.loadSheets = function () {
        const tenantId = (_this.user && _this.user.tenantId) ? _this.user.tenantId : "";
        const url = SHEETS_API_BASE + "/files/tenant/" + tenantId;

        const headers = {
            'Authorization': 'Bearer ' + (Authentication.getAccessToken ? Authentication.getAccessToken() : ''),
            'systemId': 'builder',
            'systemVersion': builderVersion,
            'userId': _this.user ? _this.user.id : '',
        };

        _this.loading = true;
        return $http.get(url, { headers: headers }).then(function (res) {
            let list = Array.isArray(res.data) ? res.data : [];
            _this.sheets = list.map(mapApiItemToSheet);
            return _this.sheets;
        }, function (err) {
            _this.sheets = [];
            return [];
        }).finally(function () {
            _this.loading = false;
        });
    };

    // Carga inicial desde el resolve; después se usa loadSheets() para recargar (crear/editar/borrar)
    this.sheets = (filesFromApi || []).map(mapApiItemToSheet);

    this.newSheet = function () {
        _this.openSheetModal(null);
    };

    this.editSheet = function (sheet) {
        _this.openSheetModal(sheet);
    };

    this.buildSheetsOpenParams = () => ({
        access_token: Authentication.getAccessToken(),
        accountId: _this.user && _this.user.id ? _this.user.id : '',
        firstName: (_this.user && _this.user.firstName) || '',
        lastName: (_this.user && _this.user.lastName) || '',
        email: (_this.user && _this.user.email) || '',
    });

    this.openSheet = ($event, sheet) => {
        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
        }
        if (sheet && sheet.id) {
            window.open(SHEETS_FRONT_DEV + '/' + sheet.id + '?' + new URLSearchParams(_this.buildSheetsOpenParams()), "_blank");
        }
    };

    this.removeSheet = function (sheet) {
        dialog
            .confirm({
                title: $translate.instant("DASHBOARD.DASH_SHEETS.DIAG_DEL.TITLE"),
                body: $translate.instant("DASHBOARD.DASH_SHEETS.DIAG_DEL.BODY", {
                    name: sheet.name,
                }),
                accept: $translate.instant("DASHBOARD.DELETE"),
                cancel: $translate.instant("DASHBOARD.CANCEL"),
                size: "sm",
            })
            .then(function () {
                // TODO: Implementar la eliminación real en el API cuando esté listo; mientras tanto recargamos la lista
                let deleteUrl = SHEETS_API_BASE + "/files/delete/" + sheet.id;

                const headers = {
                    'Authorization': 'Bearer ' + (Authentication.getAccessToken ? Authentication.getAccessToken() : ''),
                    'systemId': 'builder',
                    'systemVersion': builderVersion,
                    'userId': (_this.user && _this.user.id) ? _this.user.id : '',
                };

                return $http.delete(deleteUrl, { headers: headers }).then(function (res) {
                    toast.success($translate.instant("DASHBOARD.DASH_SHEETS.DELETED_SUCCESS"));
                    _this.loadSheets();
                }, function (err) {
                    toast.error(err.data && err.data.message ? err.data.message : $translate.instant("DASHBOARD.DASH_SHEETS.ERROR_DELETE"));
                });
            });
    };

    this.openSheetModal = function (sheet) {
        _this.currentSheet = sheet;
        _this.isEdit = !!sheet;

        _this.modalSheet = {
            id: sheet ? sheet.id : null,
            name: sheet ? sheet.name : "",
            clientId: sheet ? (sheet.clientId || "global") : "global",
            departmentId: sheet ? (sheet.departmentId || "global") : "global"
        };

        $uibModal.open({
            animation: true,
            templateUrl: "dashboard-sheets/sheetModal.html",
            controller: [
                "$scope",
                "$uibModalInstance",
                "$translate",
                "departments",
                "clients",
                function ($scope, $uibModalInstance, $translate, departments, clients) {
                    let modalCtrl = this;
                    modalCtrl.sheet = angular.copy(_this.modalSheet);
                    modalCtrl.departments = departments || [];
                    modalCtrl.clients = clients || [];
                    modalCtrl.isEdit = _this.isEdit;

                    modalCtrl.canSave = function () {
                        return modalCtrl.sheet.name &&
                            modalCtrl.sheet.name.trim() !== "" &&
                            modalCtrl.sheet.clientId &&
                            modalCtrl.sheet.clientId !== "" &&
                            modalCtrl.sheet.departmentId &&
                            modalCtrl.sheet.departmentId !== "";
                    };

                    modalCtrl.save = function () {
                        if (!modalCtrl.canSave()) {
                            toast.error($translate.instant("DASHBOARD.DASH_SHEETS.MODAL.VALIDATION_ERROR"));
                            return;
                        }
                        $uibModalInstance.close(modalCtrl.sheet);
                    };

                    modalCtrl.cancel = function () {
                        $uibModalInstance.dismiss();
                    };
                }
            ],
            controllerAs: "ctrl",
            size: "md",
            windowClass: "dialog",
            bindToController: true,
            resolve: {
                departments: function () {
                    return _this.departments;
                },
                clients: function () {
                    return _this.clients;
                }
            }
        }).result.then(function (sheetData) {
            if (_this.isEdit) {
                var putUrl = SHEETS_API_BASE + "/files/" + sheetData.id;
                var putBody = {
                    file: sheetData.name.trim(),
                    clientId: sheetData.clientId && sheetData.clientId !== "global" ? sheetData.clientId : null,
                    departmentId: sheetData.departmentId && sheetData.departmentId !== "global" ? sheetData.departmentId : null
                };

                const headers = {
                    'Authorization': 'Bearer ' + (Authentication.getAccessToken ? Authentication.getAccessToken() : ''),
                    'systemId': 'builder',
                    'systemVersion': builderVersion,
                    'userId': (_this.user && _this.user.id) ? _this.user.id : '',
                    'Content-Type': 'application/json'
                };

                $http.put(putUrl, putBody, { headers: headers }).then(function (res) {
                    toast.success($translate.instant("DASHBOARD.DASH_SHEETS.UPDATED_SUCCESS"));
                    _this.loadSheets();
                }, function (err) {
                    toast.error(err.data && err.data.message ? err.data.message : $translate.instant("DASHBOARD.DASH_SHEETS.ERROR_UPDATE"));
                });
            } else {
                var tenantId = (_this.user && _this.user.tenantId) ? _this.user.tenantId : "";
                var body = {
                    tenantId: tenantId,
                    fileName: sheetData.name.trim()
                };
                if (sheetData.clientId && sheetData.clientId !== "global") {
                    body.clientId = sheetData.clientId;
                }
                if (sheetData.departmentId && sheetData.departmentId !== "global") {
                    body.departmentId = sheetData.departmentId;
                }
                const headers = {
                    'Authorization': 'Bearer ' + (Authentication.getAccessToken ? Authentication.getAccessToken() : ''),
                    'systemId': 'builder',
                    'systemVersion': builderVersion,
                    'userId': (_this.user && _this.user.id) ? _this.user.id : '',
                };
                $http.post(SHEETS_API_BASE + "/files/new", body, { headers: headers }).then(function (res) {
                    toast.success($translate.instant("DASHBOARD.DASH_SHEETS.CREATED_SUCCESS"));
                    // Se recarga tabla
                    _this.loadSheets();
                    var newId = res?.data?.data[0]?.file?.id || res?.data?.data[0]?.file?._id;

                    // Abrir nueva pestaña con el nuevo sheet creado
                    if (newId) {
                        window.open(SHEETS_FRONT_DEV + '/' + newId + '?' + new URLSearchParams(_this.buildSheetsOpenParams()), "_blank");
                    }
                }, function (err) {
                    toast.error(err.data && err.data.message ? err.data.message : $translate.instant("DASHBOARD.DASH_SHEETS.ERROR_CREATE"));
                });
            }
        });
    };

    
}];

